/* unplugin-vue-components disabled */import { render } from "./FooterCustom.vue?vue&type=template&id=33c3f4d9&scoped=true"
import script from "./FooterCustom.vue?vue&type=script&lang=js"
export * from "./FooterCustom.vue?vue&type=script&lang=js"

import "./FooterCustom.vue?vue&type=style&index=0&id=33c3f4d9&scoped=true&lang=css"

import exportComponent from "D:\\00JH-项目\\钧舵机器人\\cn\\jodell_robotics\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c3f4d9"]])

export default __exports__